import React from 'react';
import './Header.css';

const Header = () => {
  return (
    <div className="app-header">
      <h1>✨ Thought Bubbles ✨</h1>
      <p>Click on a bubble to watch an inspiring video!</p>
    </div>
  );
};

export default Header;
